
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';

import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
// Action Object for ArtistsCatalog. Import the types from artists/types.js and Invoke Actions from the Vuex Host Components.
import router from '../../../../router';

import { statementServices } from '../../services/statements/statements.service';
import { type } from 'ramda';
import { abbreviate, keyValuesToObj } from '../../../../utility/fp';
import { EOL_REACHED } from '../../../../dt-plugins/advanced-search/load.model';

const NavTabModule = getNavTabModule(types.StatementDetails, 'statementDetails');


export const statementActions = {
  async [types.BelieveStatementList.FETCH.ALL]({ commit, getters, dispatch }, payload) {

    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    console.log("PAYLOAD", payload);

    if (searchMode == 'none') {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          statementServices.believeStatements(start, row_count, "", ""),
          statementServices.royaltyStatementsTab(),

        ]);

        console.log("res", res)
        commit(types.StatementList.SET.ALL, res);  // <-- Directly Set the Data. Depends on your particular Logic
      }
      else {                // <-- Pagination Logic
        res = await statementServices.believeStatements(start, parseInt(start) + parseInt(row_count), "", "");               // <-- Pagination Logic

        console.log("res", res)

        commit(types.StatementList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.statementList,
          statements: [
            ...getters.statementList.statements,
            ...res.data.statements, // <-- append new Fetched List
          ]
        });


        if (!(res?.data?.length <= 0)) {
          return EOL_REACHED;
        }
      }

    }
    else if (searchMode == 'basic') {
      const { searchString, period } = basicFilter;

      res = await statementServices.believeStatements(start, row_count, searchString, period);
      console.log("res", res)
      if (start == 0) {
        commit(types.StatementList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.statementList,
          statements: res.data.statements
        });
      }
      else {                // <-- Pagination Logic
        commit(types.StatementList.SET.ALL, {               // <-- Pagination Logic
          ...getters.statementList,
          statementList: [
            ...getters.statementList.statements,
            ...res.data.statements // <-- append new Fetched List
          ]
        });
      }



      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }
    else if (searchMode == 'advanced') {
      console.log({ "searchFilter": searchFilter });
      res = await statementServices.royaltyStatements({ ...searchFilter, start: start });

      if (start == 0) {
        commit(types.StatementList.SET.ALL, {
          ...getters.statementList,
          statements: res.data.statements
        });
      } else {                // <-- Pagination Logic
        commit(types.StatementList.SET.ALL, {               // <-- Pagination Logic
          ...getters.statementList,
          statementList: [
            ...getters.statementList.statements,
            ...res.data.statements // <-- append new Fetched List
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },

  async [types.StatementList.FETCH.ALL]({ commit, getters, dispatch, rootGetters }, payload) {
    const believe_special = rootGetters.account.believe_special
    if (believe_special) {
      await dispatch(types.BelieveStatementList.FETCH.ALL, payload);
    }
    else {
      await dispatch(types.DefaultStatementList.FETCH.ALL, payload);
    }
  },

  async [types.DefaultStatementList.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;


    let res;
    console.log("PAYLOAD", payload);

    if (searchMode == 'none') {
      if (start == 0) {
        res = await HttpClient.mergeRequests([
          statementServices.home(),
          statementServices.royaltyStatementsTab(),

        ]);
        commit(types.StatementList.SET.ALL, res);  // <-- Directly Set the Data. Depends on your particular Logic
      } else {                // <-- Pagination Logic
        res = await statementServices.royaltyStatementPage(start);               // <-- Pagination Logic

        console.log("res", res)

        commit(types.StatementList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.statementList,
          statements: [
            ...getters.statementList.statements,
            ...res.data.statements, // <-- append new Fetched List
          ]
        });

        // Setting EOL
        // if (!(res?.data?.length <= 0)) {
        //   return EOL_REACHED;
        // }
      }

    }
    else if (searchMode == 'basic') {
      const { searchString, period, royalty_period, invoice_project, statement_type } = basicFilter;

      res = await statementServices.filterStatements(searchString, period, royalty_period, invoice_project, statement_type);
      console.log("res", res)
      if (start == 0) {
        commit(types.StatementList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
          ...getters.statementList,
          statements: res.data.statements
        });
      }

    }

    else if (searchMode == 'advanced') {
      console.log({ "searchFilter": searchFilter });
      res = await statementServices.advanceSearchStatements({ ...searchFilter, rowStart: start });
      if (start == 0) {
        commit(types.StatementList.SET.ALL, {
          ...getters.statementList,
          statements: res.data.statements
        });
      } else {                // <-- Pagination Logic
        commit(types.StatementList.SET.ALL, {               // <-- Pagination Logic
          ...getters.statementList,
          statementList: [
            ...getters.statementList.statements,
            ...res.data.statements // <-- append new Fetched List
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    }
    //const statementOverviewData = await HttpClient.mergeRequests(promises);

    //console.log("StatementOverviewData",statementOverviewData);

    //commit(types.BelieveStatementList.SET.ALL,  statementOverviewData );
  },


  async [types.DefaultStatementList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { royalty_period_id, noDatabaseUpdate } = payload;

    commit(types.StatementList.SET.ALL, {// <-- Set the Data. Here the actual List is nested. Depends on your particular case
      statements: getters.statementList.statements.filter(e => e.royalty_period_id !== royalty_period_id)
    });

    if (noDatabaseUpdate) {
      return;
    }
    await statementServices.removeRoyaltyPeriod(royalty_period_id);



  },




  async [types.BelieveStatementList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { kVal, name, value } = payload

    commit(types.StatementList.UPDATE.SINGLE, payload)
    await MHTTPCL.modify(undefined, kVal, name, value, "l_royalty_periods");
    if (name == "lock_flag") {
      await statementServices.updateRoyaltyPeriodPayment(kVal);
    }
  },

  async [types.StatementList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { kVal, name, value } = payload

    commit(types.StatementList.UPDATE.SINGLE, payload)


    console.log("PPPPPPPPPPPPPP", { kVal, name, value })



    await MHTTPCL.modify(undefined, kVal, name, value, "l_royalty_periods");
    if (name == "lock_flag") {
      await statementServices.updateRoyaltyPeriodPayment(kVal);
    }
  },


  async [types.StatementDetails.FETCH.SINGLE]({ commit, getters, dispatch, rootGetters }, payload) {

    const believe_special = rootGetters.account.believe_special;

    if (believe_special) {
      //dispatch believe
      dispatch(types.BelieveStatementDetails.FETCH.SINGLE, payload);
    } else {
      dispatch(types.DefaultStatementDetails.FETCH.SINGLE, payload);
    }
  },

  async [types.DefaultStatementDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, statement, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'royalty_period_id';
    const itemName = 'statement';
    const item = payload[itemName];

    const { royalty_period_id } = statement;

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'statementDetails';
    const DetailsAction = types.StatementDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (_, oldSingleDetails) => {
      return {
        ...oldSingleDetails,
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req
    let promises = [
      statementServices.royaltyPeriodStatementTab(royalty_period_id, ""),
    ];

    const detailsData = await HttpClient.mergeRequests(promises);


    console.log("DETaIlS OF RESponSE", detailsData);

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        ...detailsData,
        loading: false,
      }
    });

    console.log("getters.statementDetails", getters.statementDetails);
  },


  async [types.BelieveStatementDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, statement, reload } = payload;

    const { royalty_period_id } = statement;
    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = 'royalty_period_id';
    const itemName = 'statement';
    const item = payload[itemName];

    console.log('payload itemName', item);

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'statementDetails';
    const DetailsAction = types.BelieveStatementDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (_, oldSingleDetails) => {
      return {
        ...oldSingleDetails,
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req
    let promises = [
      statementServices.royaltyPeriodStatementTabBelieve(royalty_period_id, ""),
    ]

    const detailsData = await HttpClient.mergeRequests(promises);

    console.log("DETaIlS OF RESponSE", detailsData);

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, statement) => {
      return {
        ...statement,
        ...detailsData,
        loading: false,
      }
    });

    console.log("getters.statementDetails", getters.statementDetails);
  },


  async [types.StatementDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item } = payload
    const { statement } = item;
    const { royalty_period_id } = statement;



    commit(types.StatementList.UPDATE.SINGLE, { kVal: royalty_period_id, name, value })
    console.log("types.StatementDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(royalty_period_id, (selectedStatementDetails) => {
      return {

        statement: {
          ...selectedStatementDetails.statement,
          [name]: value,
        }
      }
    });

    const modifiedRelease = await MHTTPCL.modifyJSON('', royalty_period_id, name, value, 'l_royalty_periods');
  },

  async [types.StatementPayment.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { royalty_period_id, json_data } = payload;
    NavTabHelper.updateSingleNavTabDetails(royalty_period_id, (selectedStatementDetails) => {
      return {
        response: {
          ...selectedStatementDetails.response,
          rp: {
            ...selectedStatementDetails.response.rp,
            json_data,
          }
        }
      }
    });
  },


  async [types.Log.DELETE.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item } = payload
    const { statement } = item;
    const { royalty_period_id } = statement;

    console.log("WERE")

    NavTabHelper.updateSingleNavTabDetails(royalty_period_id, (selectedStatementDetails) => {
      return {
        response: {
          ...selectedStatementDetails.response,
          rp: {
            ...selectedStatementDetails.response.rp,
            send_log: ''
          }
        }
      }
    });

    await statementServices.emptyStatementLog(royalty_period_id)

  },

  async [types.TaxDeduction.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, value } = payload
    const { statement } = item;
    const { royalty_period_id } = statement;

    const resData = await statementServices.modifyStatementTaxDeduction(royalty_period_id, '', value);
    console.log("RES DATA", resData);

    NavTabHelper.updateSingleNavTabDetails(royalty_period_id, (selectedStatementDetails) => {
      return {
        response: {
          ...selectedStatementDetails.response,
          stmt_summary: resData.data.stmt_summary

        }
      }
    });


  },

  async [types.RoyaltyStatementVatRate.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, value } = payload
    const { statement } = item;
    const { royalty_period_id } = statement;

    const resData = await statementServices.modifyStatementVatRate({ royalty_period_id: royalty_period_id, royalty_period_bundle_id: '', vat_rate: value.value });
    console.log("RES DATA", resData, "::::", payload);

    NavTabHelper.updateSingleNavTabDetails(royalty_period_id, (selectedStatementDetails) => {
      return {
        response: {
          ...selectedStatementDetails.response,
          stmt_summary: resData.data.stmt_summary

        }
      }
    });


  },

  async [types.ClOSING_STATEMENT]({ commit, getters, dispatch }, payload) {

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { selectedStatementDetails } = payload
    const { statement } = selectedStatementDetails;
    const { royalty_period_id } = statement;

    await statementServices.swapPaymentClosing(royalty_period_id, "");

    dispatch(types.StatementDetails.FETCH.SINGLE, {
      flag: true,
      statement,
      reload: true,
    });

    // NavTabHelper.setSingleNavTabDetails(royalty_period_id, (_, oldSingleDetails) => {
    //   return {
    //     ...oldSingleDetails,
    //     statement: item,
    //     loading: true,
    //   }
    // });

    // setTimeout(NavTabHelper.setSingleNavTabDetails(royalty_period_id, (_, oldSingleDetails) => {
    //   return {
    //     ...oldSingleDetails,
    //     statement: item,
    //     loading: false,
    //   }
    // }),60000);





  },



  ...NavTabModule.implementActions(
    'royalty_period_id',
    'statements/royalty_period_id/tab',
    'statements',
    () => router,
    'royalty',
    (value, key) => {
      console.log("KEY::", key, "value::", value);

      return {
        title: value?.response?.ra?.royalty_account_name ? `${abbreviate(value?.response?.ra?.royalty_account_name, 10)} ${value?.response?.rp?.start_date}-${value?.response?.rp?.end_date}` : key,
        full_title: value?.response?.ra?.royalty_account_name ? `${value?.response?.ra?.royalty_account_name} ${value?.response?.rp?.start_date}-${value?.response?.rp?.end_date}` : key,
      }
    }
  ),


  // [types.StatementDetails.FETCH.ALL], <-- Convention + NavTabHelper

  // [types.DefaultStatementDetails.FETCH.ALL],
  // [types.BelStatementDetails.FETCH.ALL],



}
